import { Text } from "@chakra-ui/react"

type ErrorTextProps = {
  colorMode?: "dark" | "light"
}
const ErrorText = ({ colorMode = "light" }: ErrorTextProps) => {
  return <Text color={colorMode === "dark" ? "gray.100" : "gray.800"}>壞掉了！</Text>
}

export default ErrorText
